import React from 'react';
var SnippylyArrows = function () {
    return (React.createElement("velt-arrows", null));
};
export default SnippylyArrows;
